import styles from "./styles.module.scss";

const Checkbox = ({
  checked,
  onChange,
  label,
  isSquare = false,
  greyText = false,
  boldText = false,
  iconType = false,
  name,
  disabled = false, // New disabled prop
}) => {
  return (
    <label
      className={`${styles.checkbox} ${greyText ? styles.greyText : ""} ${
        iconType ? styles.iconCheck : ""
      } ${disabled ? styles.disabled : ""}`} // Apply disabled styles
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        name={name}
        disabled={disabled} // Disable the checkbox
      />
      <span
        className={`${styles.checkmark} ${isSquare ? styles.isSquare : ""}`}
      ></span>
      <span className={boldText ? styles.boldText : ""}>{label}</span>
    </label>
  );
};

export default Checkbox;
